import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import Paginator from 'Components/Paginator';
import SelectInput, { findItem } from 'Components/forms/select-input';
import GDTableRecordsCount from 'Components/GDTable/GDTableRecordsCount';

import './GDTableFooter.scss';

class GDTableFooter extends Component {
  constructor(props) {
    super(props);

    const dataList = this.props.translations?.paginationDropdownoptions != null 
    ?
    this.props.translations?.paginationDropdownoptions 
    :
    [
      {
        value: 25,
        text: this.props.translations.show25perPage,
      },
      {
        value: 50,
        text: this.props.translations.show50perPage,
      },
      {
        value: 75,
        text: this.props.translations.show75perPage,
      },
      {
        value: 100,
        text: this.props.translations.show100perPage,
      },
    ];

    this.state = {
      dataList,
      selectedItem: dataList[0],
      acquirerCode:JSON.parse(sessionStorage.getItem("state")).auth.user.acquirerCode,
    };
  }

  componentDidMount() {
    this.setValueTranslation();
  }

  handleSelection = (value, event) => {
    event.stopPropagation();
    const newSelection = findItem(this.state.dataList, value);
    if (
      newSelection &&
      Number.isInteger(newSelection.value) &&
      newSelection.value !== this.props.recordsShown
    ) {
      const newPerPage = newSelection.value;
      const newPage = 1; // always reset to the first page when changing the number per page
      this.setState(
        { selectedItem: newSelection },
        this.props.pageHandler(newPage, newPerPage),
      );
    }
  };

  setValueTranslation = () => {
    if (this.props.recordsShown === 5) {
      this.setState({ selectedItem: { value: 5, text: this.props.translations.show5perPage } });
    } else if (this.props.recordsShown === 10) {
      this.setState({ selectedItem: { value: 10, text: this.props.translations.show10perPage } });
    } else if (this.props.recordsShown === 15) {
      this.setState({ selectedItem: { value: 15, text: this.props.translations.show15perPage } });
    } else if (this.props.recordsShown === 20) {
      this.setState({ selectedItem: { value: 20, text: this.props.translations.show20perPage } });
    } else if (this.props.recordsShown === 25) {
      this.setState({ selectedItem: { value: 25, text: this.props.translations.show25perPage } });
    } else if (this.props.recordsShown === 50) {
      this.setState({ selectedItem: { value: 50, text: this.props.translations.show50perPage } });
    } else if (this.props.recordsShown === 75) {
      this.setState({ selectedItem: { value: 75, text: this.props.translations.show75perPage } });
    } else if (this.props.recordsShown === 100) {
      this.setState({
        selectedItem: { value: 100, text: this.props.translations.show100perPage }, });
    }
  };

  render() {
    const wrapperClass = classnames('gd-table__footer', {
      [this.props.extraClass]: this.props.extraClass,
    });

    const promptText = this.state.dataList[0].text;
    return (
      <div className={wrapperClass}>
        <div className="gd-table__footer-left">
          <SelectInput
            dataList={this.state.dataList}
            handleSelection={this.handleSelection}
            selectedItem={this.state.selectedItem}
            promptText={promptText}
           wrapperClass={"select-menu__form "+this.state.acquirerCode}
            id={(this.props.isrelatedSearchLoaded === true? `${this.props.id}_SelectInput gridOpen` : (this.props.tableCss === "tableAppSearch"? `${this.props.id}_SelectInput gridOpen`: `${this.props.id}_SelectInput`))}
          />
          <GDTableRecordsCount
            totalRecords={this.props.totalRecords}
            text={this.props.recordsCountText}
            currentPage={this.props.currentPage}
            recordsShown={this.props.recordsShown}
            isNextPage={this.props.isNextPage}
            isPagable={this.props.isPagable}
          />
        </div>
        <Paginator
          tableCss = {this.props.tableCss}
          isrelatedSearchLoaded={this.props.isrelatedSearchLoaded}
          currentPage={this.props.currentPage}
          totalPages={this.props.totalPages}
          pageHandler={this.props.pageHandler}
          translations={this.props.translations}
          id={(this.props.isrelatedSearchLoaded === true? `${this.props.id}_Paginator gridOpen` : `${this.props.id}_Paginator`)}
          //id={`${this.props.id}_Paginator`}
        />
      </div>
    );
  }
}

GDTableFooter.propTypes = {
  currentPage: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
    .isRequired,
  extraClass: PropTypes.string,
  isNextPage: PropTypes.bool,
  pageHandler: PropTypes.func.isRequired,
  recordsCountText: PropTypes.object.isRequired,
  recordsShown: PropTypes.number,
  totalPages: PropTypes.number.isRequired,
  totalRecords: PropTypes.number.isRequired,
  translations: PropTypes.object.isRequired,
  id: PropTypes.string,
  isGridCompact: PropTypes.bool,
  isCellborder: PropTypes.bool,
};

GDTableFooter.defaultProps = {
  extraClass: '',
  isNextPage: false,
  recordsShown: 25,
  id: '',
  isGridCompact: false,
  isCellborder: false,
};

export default GDTableFooter;
